import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
import useArchiveConfig from "archive/hooks/useArchiveConfig";
const useExcludedStreams = () => {
  var _a;
  const { permissions } = useCurrentUser();
  const { data } = useArchiveConfig({ enabled: isPermitted(permissions, "archiveconfig:read") });
  return (_a = data == null ? void 0 : data.excluded_streams) != null ? _a : [];
};
export default useExcludedStreams;
